import React, { useState, useEffect } from "react";

const NoSession = ({ count }) => {
    const [countdown, setCountdown] = useState(count);

    useEffect(() => {
        if (countdown === 0) return;

        const timer = setInterval(() => {
            setCountdown((prevCount) => prevCount - 1);
        }, 1000);

        return () => clearInterval(timer); // Clear the interval when the component unmounts
    }, [countdown]);

    return (
        <div className="session_alert fade-in">
            Your session has expired. <br />
            You will be redirected to the login page in {countdown} seconds.
        </div>
    );
};

export default NoSession;
